import React, { createContext, useEffect, useState } from 'react';
import { Layout } from 'antd';
import { useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import styles from './index.module.scss';
import DragResize from '@/components/DragResize';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import EnergyTree from './EnergyTree';
import UnitDetail from './UnitDetail';
import dayjs, { Dayjs } from 'dayjs';
import { EnergyUnitItem } from '@/api/energyUnitDashboard';
import EnergyAnalysisOverview from './EnergyAnalysisOverview';
import {
  apiV2EnergyMediumPhysicalUnitByUnitGroupPost,
  V2EnergyMediumPhysicalUnitByUnitGroupPostResponse,
} from '@maxtropy/device-customer-apis-v2';
const { Content, Sider } = Layout;

type RangeValue = [Dayjs | null, Dayjs | null] | null;

export const EnergyUnitContext = createContext<{
  groupId?: number;
  unitId?: number;
  setGroupId?: (groupId: number) => void;
  setUnitId?: (unitId: number | undefined) => void;
  showDetail?: boolean;
  setShowDetail?: (showDetail: boolean) => void;
  setTime?: (time: RangeValue) => void;
  time?: RangeValue;
}>({});

const EnergyUnitKanban: React.FC = () => {
  const [openSider, setOpenSider] = useState(true);
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [groupId, setGroupId] = useState<number>();
  const [unitId, setUnitId] = useState<number>();

  const [unitPath, setUnitPath] = useState<string>('');
  const [time, setTime] = useState<RangeValue>([dayjs().subtract(30, 'day'), dayjs()]);
  const [defaultData, setDefaultData] = useState<EnergyUnitItem[]>([]);
  const [energyUnitList, setEnergyUnitList] = useState<V2EnergyMediumPhysicalUnitByUnitGroupPostResponse['data']>();

  // 初始值
  const [siderWidth, setSiderWidth] = useState(260);
  // 拖拽状态
  const [dragStatus, setDragStatus] = useState(false);

  const dragChange = (width: number) => {
    if (openSider) {
      setSiderWidth(width);
    }
  };

  // 查询单位
  useEffect(() => {
    if (!groupId) return;
    apiV2EnergyMediumPhysicalUnitByUnitGroupPost({ energyUnitGroupId: groupId }).then(res => {
      setEnergyUnitList(res.data);
    });
  }, [groupId]);

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} hasPadding={false}>
      <EnergyUnitContext.Provider
        value={{ groupId, unitId, setGroupId, setUnitId, showDetail, setShowDetail, setTime, time }}
      >
        <Layout className={styles.layout}>
          <Sider
            className={styles.siderDemo}
            width={openSider ? siderWidth : 0}
            style={{ transition: dragStatus ? 'none' : 'all 0.2s' }}
          >
            <DragResize init={260} dragChange={dragChange} dragStatus={setDragStatus} />
            <EnergyTree
              setNodePath={path => setUnitPath(path)}
              defaultData={defaultData}
              setDefaultData={setDefaultData}
            />
          </Sider>
          <Content className={styles.content} style={{ marginLeft: openSider ? 10 : 0 }}>
            <div className="toggleBtn" style={{ left: openSider ? -30 : 0 }} onClick={() => setOpenSider(!openSider)}>
              {openSider ? <LeftOutlined /> : <RightOutlined />}
            </div>
            {showDetail ? (
              // 详情页
              <UnitDetail unitPath={unitPath} times={time} defaultData={defaultData} energyUnitList={energyUnitList} />
            ) : (
              <>
                {/* 用能分析总览 */}
                <EnergyAnalysisOverview groupId={groupId} />
              </>
            )}
          </Content>
        </Layout>
      </EnergyUnitContext.Provider>
    </Wrapper>
  );
};

export default EnergyUnitKanban;
